import React from "react";
import footerImg from "../../assets/images/foot.png";

const FootTwo = ({ data }) => {
  if (!data) return null;
  return (
    <>
      <div className="foot-box-1" style={{ paddingTop: "15px" }}>
        <h4>{data.title}</h4>
        <div dangerouslySetInnerHTML={{ __html: data.description }} />
        {data.img1 && <img src={data.img1} alt="footerImg" />}
      </div>
    </>
  );
};

export default FootTwo;
